import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceinhinjewadi() {



const cardData =
  {
    keyword: 'Corporate Cab Service in Hinjewadi',
    heading: 'Sanavi Travels: Corporate Cab Service in Hinjewadi',
    headingDescription: 'Sanavi Travels provides a highly reliable, professionally managed, and scalable Corporate Cab Service in Hinjewadi, specially designed for IT companies, MNCs, startups, software parks, business centers, and corporate offices operating across Hinjewadi Phase 1, Phase 2, Phase 3, and surrounding areas. Hinjewadi is Pune’s largest IT and corporate hub, where punctuality, safety, and organized transportation play a critical role in business continuity and employee satisfaction. Our corporate cab services in Hinjewadi are structured to handle daily office commute, employee pickup and drop, airport transfers, railway station transfers, corporate meetings, client visits, conferences, seminars, and long-term corporate transportation contracts. Sanavi Travels offers AC and Non-AC sedans and SUVs with fixed-route planning, flexible shift timings, trained and background-verified drivers, and centralized coordination support. We understand the complexities of IT shift operations, night shifts, rotational schedules, and high-volume employee movement, and our services are designed to ensure zero disruption, on-time performance, and safe travel at all hours. With GPS-enabled vehicles, route optimization, backup cabs, driver replacement policies, transparent billing with GST invoices, and 24/7 operational support, Sanavi Travels ensures seamless corporate mobility across Hinjewadi and its connectivity corridors. Choosing Corporate Cab Service in Hinjewadi with Sanavi Travels means reduced operational burden, controlled travel costs, improved employee punctuality, enhanced safety, and a professional transportation partner that aligns with corporate standards and expectations.',

    top: 'Corporate Transportation Use Cases in Hinjewadi',


"topPlaces": [
  {
    "title": "IT Company Office Commute",
    "description": "Corporate cab service in Hinjewadi is most commonly used for daily office commute of IT professionals working across Phase 1, Phase 2, and Phase 3. With structured pickup and drop schedules, predefined routes, and reliable vehicles, employees reach offices on time without dependency on public transport or personal vehicles. This improves punctuality, reduces stress, and enhances overall workforce productivity."
  },
  {
    "title": "Employee Pickup and Drop Services",
    "description": "Employee pickup and drop services are critical in Hinjewadi due to rotational shifts and night operations. Corporate cabs ensure safe, organized, and timely transport for employees working early morning, late night, or graveyard shifts. Fixed cab allocation and trained drivers enhance safety and reliability."
  },
  {
    "title": "Corporate Airport Transfers",
    "description": "Corporate airport cab services from Hinjewadi ensure executives, employees, and business guests reach Pune Airport on time. With flight monitoring, buffer-time planning, and professional chauffeurs, airport transfers become smooth and stress-free."
  },
  {
    "title": "Railway Station Transfers",
    "description": "Corporate cab services for railway station pickup and drop support employees and executives traveling for official work. Organized transfers eliminate last-minute delays and coordination issues."
  },
  {
    "title": "Client and Guest Transportation",
    "description": "Corporate client and guest transportation in Hinjewadi helps companies manage travel for visitors, partners, and international delegates. Professional cab services create a positive first impression and smooth business interactions."
  },
  {
    "title": "Corporate Meetings and Office Visits",
    "description": "Executives attending meetings across Pune use corporate cabs from Hinjewadi for efficient inter-office travel. Comfortable vehicles allow teams to travel together and maintain productivity."
  },
  {
    "title": "Conferences and Seminars",
    "description": "Hinjewadi hosts frequent conferences, seminars, and corporate events. Corporate cab services ensure smooth transportation of attendees, speakers, and organizing teams."
  },
  {
    "title": "Long-Term Corporate Contracts",
    "description": "Many companies in Hinjewadi opt for long-term corporate cab contracts for daily commute and employee transport. This ensures consistent service quality, predictable costs, and operational stability."
  },
  {
    "title": "Night Shift Corporate Transport",
    "description": "Night shift operations require enhanced safety and reliability. Corporate cabs with trained drivers and tracking systems ensure secure travel for employees during late hours."
  },
  {
    "title": "Multi-Location Corporate Travel",
    "description": "Companies operating across multiple office locations use corporate cabs to move teams between sites efficiently, reducing travel complexity and time wastage."
  }
]
,



"services": [
{
"name": "Corporate Cab Service in Hinjewadi",
"description": "Corporate Cab Service in Hinjewadi by Sanavi Travels delivers a complete transportation solution for IT companies and corporate offices. This service supports daily office commute, employee pickup and drop, airport transfers, meetings, and long-term corporate travel requirements. With fixed schedules, trained drivers, GPS-enabled vehicles, and centralized coordination, organizations benefit from punctual, safe, and cost-controlled corporate mobility."
},
{
"name": "Hinjewadi Corporate Cab Hire",
"description": "Hinjewadi Corporate Cab Hire offers flexible cab deployment for businesses requiring structured employee and executive transportation across all phases of Hinjewadi."
},
{
"name": "AC Corporate Cab Hinjewadi",
"description": "AC Corporate Cab Hinjewadi ensures comfortable daily travel for employees and executives, especially during peak hours and long-distance commute."
},
{
"name": "Non AC Corporate Cab Hinjewadi",
"description": "Non AC Corporate Cab Hinjewadi provides economical corporate transport while maintaining safety, punctuality, and professional service standards."
},
{
"name": "Sedan Corporate Cab Hinjewadi",
"description": "Sedan Corporate Cab Hinjewadi is ideal for individual executives and small teams requiring efficient and comfortable business travel."
},
{
"name": "SUV Corporate Cab Hinjewadi",
"description": "SUV Corporate Cab Hinjewadi supports group travel, management commute, and luggage requirements with enhanced space and comfort."
},
{
"name": "Corporate Cab for Office Commute Hinjewadi",
"description": "Corporate Cab for Office Commute Hinjewadi ensures employees reach offices on time every day, improving attendance and productivity."
},
{
"name": "Corporate Cab for IT Companies Hinjewadi",
"description": "Corporate Cab for IT Companies Hinjewadi is designed to handle high-volume employee transport with shift-based scheduling and operational reliability."
},
{
"name": "Corporate Cab for Airport Hinjewadi",
"description": "Corporate Cab for Airport Hinjewadi provides timely and well-coordinated airport transfers for executives, employees, and business guests."
},
{
"name": "Corporate Cab for Railway Hinjewadi",
"description": "Corporate Cab for Railway Hinjewadi supports organized railway station transfers for official travel and project movement."
},
{
"name": "Affordable Corporate Cab Service Hinjewadi",
"description": "Affordable Corporate Cab Service Hinjewadi offers competitive pricing, transparent billing, and cost-effective long-term solutions."
},
{
"name": "Best Corporate Cab Service Hinjewadi",
"description": "Best Corporate Cab Service Hinjewadi by Sanavi Travels is trusted for punctuality, safety, driver quality, and operational excellence."
},
{
"name": "Corporate Cab with Driver Hinjewadi",
"description": "Corporate Cab with Driver Hinjewadi includes trained, background-verified drivers experienced in corporate travel protocols."
},
{
"name": "Corporate Cab for Employee Transport Hinjewadi",
"description": "Corporate Cab for Employee Transport Hinjewadi ensures safe and consistent workforce mobility across shifts and locations."
},
{
"name": "Corporate Cab for Meetings Hinjewadi",
"description": "Corporate Cab for Meetings Hinjewadi enables executives and teams to travel together efficiently for business engagements."
}
],
"tableData": [
["Corporate Cab Hinjewadi", "IT Company Cab Hinjewadi"],
["Employee Transport Hinjewadi", "Office Commute Cab"],
["Airport Corporate Cab", "Railway Corporate Cab"],
["Sedan Corporate Cab", "SUV Corporate Cab"],
["Affordable Corporate Cab", "Best Corporate Cab Service"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Corporate Transport Expertise",
    "WhyChoosedescription": "Sanavi Travels specializes in managing large-scale corporate cab operations in Hinjewadi."
  },
  {
    "WhyChooseheading": "Punctual and Reliable Operations",
    "WhyChoosedescription": "Structured scheduling and route planning ensure on-time pickups and drops."
  },
  {
    "WhyChooseheading": "Trained Corporate Drivers",
    "WhyChoosedescription": "Drivers are trained in corporate etiquette, safety standards, and shift operations."
  },
  {
    "WhyChooseheading": "Flexible Vehicle Options",
    "WhyChoosedescription": "Sedans and SUVs in AC and Non-AC variants suit diverse corporate needs."
  },
  {
    "WhyChooseheading": "Transparent Corporate Billing",
    "WhyChoosedescription": "Clear pricing and GST invoices simplify expense tracking and compliance."
  },
  {
    "WhyChooseheading": "Night Shift Safety Focus",
    "WhyChoosedescription": "Enhanced safety protocols ensure secure travel during late-night operations."
  },
  {
    "WhyChooseheading": "Backup and Support System",
    "WhyChoosedescription": "Backup vehicles and drivers ensure uninterrupted service continuity."
  },
  {
    "WhyChooseheading": "Trusted Corporate Partner",
    "WhyChoosedescription": "Sanavi Travels is trusted by IT companies for consistent and professional cab services."
  }
]

}

const faqData = [
  {
    question: 'Do you provide corporate cab services in Hinjewadi?',
    answer: 'Yes, Sanavi Travels offers dedicated corporate cab services across all phases of Hinjewadi.'
  },
  {
    question: 'Is employee pickup and drop available?',
    answer: 'Yes, structured employee pickup and drop services are available for all shifts.'
  },
  {
    question: 'Are AC and Non AC cabs available?',
    answer: 'Yes, both AC and Non AC sedans and SUVs are available.'
  },
  {
    question: 'Do you support night shift transport?',
    answer: 'Yes, we provide safe and reliable night shift corporate transport.'
  },
  {
    question: 'Is long-term corporate contract available?',
    answer: 'Yes, long-term and monthly corporate cab contracts are available.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Nitin Kulkarni',
    feedback: 'Very reliable corporate cab service for our IT office in Hinjewadi.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Radhika Sharma',
    feedback: 'Employee pickup and drop service is well managed and punctual.',
    rating: 5
  }
];






























  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Service in Hinjewadi - Sanavi Travels",
  "description": "Sanavi Travels offers corporate cab services in Hinjewadi for office commute, IT company transport, airport and railway pickups, employee transport, and meetings. AC and Non-AC sedans and SUVs are available with professional drivers at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "10000+"
  }
};






  return (
    <div>

<Helmet>
  <title>
    Call : +91 7387507373 | Corporate Cab Service in Hinjewadi | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book corporate cab service in Hinjewadi with Sanavi Travels. AC & Non-AC sedans and SUVs for office commute, IT companies, airport, railway, employee transport, and meetings with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/258.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviceinhinjewadi;